'use client';

import useAuth from '@/hooks/use-auth';

export default function AuthProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  useAuth();
  return <>{children}</>;
}
